// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__vxcNY","column":"style_column__Kd6hw","footerLogo":"style_footerLogo__0QBNN","disclaimer":"style_disclaimer__rVaxE","appMenuIcon":"style_appMenuIcon__-ucWx"};